import { Helmet } from 'react-helmet';
import CompanyTradeData from 'src/features/CompanyTradeData';
import MainLayout from 'src/layouts';

const CompanyTradeDataPage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>Company Trade Data</title>
      </Helmet>
      <CompanyTradeData />
    </MainLayout>
  );
};

export default CompanyTradeDataPage;
